import { defineMessages } from 'react-intl';

export const dagMessages = defineMessages({
  userCodeLabel: {
    id: 'oauth.dag.userCode.label',
    defaultMessage: 'Device code',
    description: 'Label for the user-code input field in the device authorization flow',
  },
  userCodeDescription: {
    id: 'oauth.dag.userCode.description',
    defaultMessage: 'Enter the code displayed on your device to authorize it.',
    description: 'Helper text below the user-code input',
  },
  userCodePlaceholder: {
    id: 'oauth.dag.userCode.placeholder',
    defaultMessage: 'e.g. WDJB-MJHT',
    description: 'Placeholder text inside the user-code input field',
  },
  userCodeIncomplete: {
    id: 'oauth.dag.userCode.incomplete',
    defaultMessage: 'Please enter the complete 8-character device code.',
    description: 'Error shown when the user submits without filling all code fields',
  },
  antiphishingWarning: {
    id: 'oauth.dag.userCode.antiphishingWarning',
    defaultMessage:
      "Enter the code displayed in the app or on the device you're signing in to. Never use a code sent by someone else.",
    description: 'Anti-phishing warning shown below the device code input',
  },
});
